import { immerable } from 'immer';
import { OrderedMap } from 'immutable';

import { ColumnInfo } from '../../../core/dc-core-types';

/** The shape AvailableVersionEntity guarantees; widen it as the feature grows. */
interface IAvailableVersionEntity {
	id: number;
	version: string;
	switchable: boolean;
	active: boolean;
	columns: OrderedMap<string, ColumnInfo>;
}

const entityDefaults: IAvailableVersionEntity = {
	id: -1,
	version: '',
	switchable: false,
	active: false,
	columns: OrderedMap(),
};

export class AvailableVersionEntity implements IAvailableVersionEntity {
	private [immerable] = true;

	public id = entityDefaults.id;

	public version = entityDefaults.version;

	public switchable = entityDefaults.switchable;

	public active = entityDefaults.active;

	public columns = entityDefaults.columns;

	/**
	 * Entities are built rather than constructed so that a partial payload still
	 * yields a fully populated instance.
	 */
	public static build(
		params: Partial<IAvailableVersionEntity> = {}
	): AvailableVersionEntity {
		const instance = new AvailableVersionEntity();

		instance.id = params.id ?? entityDefaults.id;
		instance.version = params.version ?? entityDefaults.version;
		instance.switchable = params.switchable ?? entityDefaults.switchable;
		instance.active = params.active ?? entityDefaults.active;
		instance.columns = params.columns ?? entityDefaults.columns;

		return instance;
	}
}
